import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MessageCircle, Phone } from "lucide-react";

export type TabType = "chat" | "voice";

interface WidgetTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

/**
 * Tabbed navigation for Chat/Voice widget
 * Uses shadcn Tabs component
 */
export function WidgetTabs({ activeTab, onTabChange }: WidgetTabsProps) {
  return (
    <div className="px-3 pt-2 bg-background/50 backdrop-blur-sm">
      <Tabs
        value={activeTab}
        onValueChange={(value) => onTabChange(value as TabType)}
        className="w-full"
      >
        <TabsList className="w-full grid grid-cols-2 h-10">
          <TabsTrigger value="chat" className="gap-2">
            <MessageCircle className="w-4 h-4" />
            Chat
          </TabsTrigger>
          <TabsTrigger value="voice" className="gap-2">
            <Phone className="w-4 h-4" />
            Talk to us
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
